import { QueryClient } from '@tanstack/react-query';

/** Shared QueryClient for the app — cleared on logout via performLogout. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});
